import React, { useEffect, useRef, useState } from "react"
// import PropTypes from 'prop-types';
import { Button, Form, Image, Input, notification, Select } from 'antd';
import { useHistory } from "react-router-dom";
import { Helpers } from "../../config/Helpers";
import { Request } from "../../config/Request";
import { URL } from "../../config/Constants";
import swal from "sweetalert";
import Images from "../../config/Images";
import Swal from 'sweetalert2';

import './Styles.css'
import 'antd/dist/antd.css';
import 'aos/dist/aos.css';
import Icons from "../../config/Icons";


export default function Login(props) {
    const navigate = useHistory()

    const [login, setLogin] = useState("");
    const [pass, setPass] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingForgot, setIsLoadingForgot] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {

    }, [])

    const onChangeFields = (values, allValues) => {
        setLogin(allValues[0].value)
        setPass(allValues[1].value)
    };
    const onFinishFailed = ({ values, errorFields, outOfDate }) => {
    }

    const validate = async () => {
        setIsLoading(true)
        let data = {
            email: login,
            password: pass
        }
        let url = URL.auth
        let resultAuth = await Request.post(url, data)
        setIsLoading(false)
        if (resultAuth.success) {
            Helpers.setUser(resultAuth.data)
            let token = {
                "token": resultAuth.data.token
            }
            await Helpers.setToken(token)
            // window.location.href = "/dashboard";
            navigate.push("/dashboard");
        }
        else {
            swal({
                title: "Accès non autorisée !",
                text: "Veuillez vérifier l'email ou le mot de passe",
                icon: "error",
                button: "OK !",
            }).then((value) => {
                // navigate('/');
            });
        }


        // props.connect()
        // navigate('/dashboard')
    };
    const _onForgotMdp = async () => {
        const { value: email } = await Swal.fire({
            title: 'Mot de passe oublié',
            input: 'email',
            inputLabel: 'Adresse Email',
            inputPlaceholder: "Entrer l'adresse email",
            confirmButtonText: 'Envoyer',
            showLoaderOnConfirm: true,
            preConfirm: async (email) => {
                Swal.showLoading()
                let data = {
                    email: email
                }
                let url = URL.postForgotPassword
                let resultForgot = await Request.post(url, data)
                // console.log(resultForgot)
                Swal.hideLoading()
                Swal.fire(`Un Email a été envoyé sur votre boîte email`)
            },
        })

        // if (email) {
        //     let data = {
        //         email: email
        //     }
        //     let url = URL.postForgotPassword
        //     let resultForgot = await Request.post(url, data)
        //     Swal.showLoading()
        //     console.log(resultForgot)
        //     Swal.hideLoading()
        //     Swal.fire(`Un Email a été envoyé sur votre boîte email`)
        // }
    }

    return (
        <div className="containerG">
            <div className="containerLogin">
                <div className="componentLoginStyle">
                    <Image
                        className=''
                        alt={"permis de construire"}
                        preview={false}
                        width={150}
                        src={Icons.icLogoBleu}
                    />
                    <Form
                        form={form}
                        name="form-login"
                        className="container-log"
                        onFinish={validate}
                        onFieldsChange={onChangeFields}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                    >
                        <div className="containerFormulaire">
                            {/* <h2 className='styleTitle'>Connexion</h2> */}
                            <p className='styleDescription'>Connectez-vous</p>
                            <div className="containerForm">
                                <label className="labelAuth">{"Email"}</label>
                                <Form.Item
                                    name="login"
                                    label=""
                                    className="content-form-login"
                                    rules={[

                                        {
                                            required: true,
                                            message: 'Login obligatoire !',
                                        },
                                    ]}
                                >
                                    <Input
                                        type={"text"}
                                        style={{ width: 'calc(100%)' }}
                                        size="large"
                                        placeholder="nom d'utilisateur..." />
                                </Form.Item>
                            </div>
                            <div className="containerForm">
                                <label className="labelAuth">{"Mot de passe"}</label>
                                <Form.Item
                                    name="pass"
                                    label=""
                                    className="content-form-login"
                                    rules={[

                                        {
                                            required: true,
                                            message: 'Mot de passe obligatoire !',
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        type={"password"}
                                        style={{ width: 'calc(100%)' }}
                                        size="large"
                                        placeholder="mot de passe..." />
                                </Form.Item>
                            </div>
                            {/* <input className="btnSubmit" type="submit" value="Se connecter" /> */}
                            <div className="containerBouton">
                                <Button
                                    htmlType="submit"
                                    size="large"
                                    type="primary"
                                    loading={isLoading}
                                    style={{ margin: '0 15px', width: 'calc(90%)', borderRadius: '10px' }}>
                                    Se connecter
                                </Button>
                            </div>
                            <div className="containerLink" onClick={() => _onForgotMdp()}>
                                <p /*href='/mot-de-passe-oublie'*/ className='styleLink'>Mot de passe oublié ? </p>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}
// Login.propTypes = {
//     // setToken: PropTypes.func.isRequired,
//     // setUserData: PropTypes.func.isRequired,
// };